<template>
	<div class="guige">
		<el-table :data="guigezu" style="width: 100%" border>
			<el-table-column label="名称" width="280">
				<template slot="header" slot-scope="scope">
					<span>名称</span>
					<span class="el-icon-circle-plus-outline tianjia_zu" @click="Tianjia_zu"></span>
				</template>
				<template slot-scope="shu">
					<el-input v-model="shu.row.ming" @change="Bianhua" />
				</template>
			</el-table-column>
			<el-table-column label="项">
				<template slot-scope="shu">
					<el-tag v-for="(l,i) in shu.row.guige" :key="i" closable @close="Shanchu(shu.row.guige,i)">
						<img :src="l.tu" v-if="l.tu" />
						<span @click="Mianbandakai(shu,i)">{{l.ming}}</span>
					</el-tag>
					<span class="el-icon-circle-plus-outline" @click="Mianbandakai(shu)"></span>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="shu">
					<span class="el-icon-close" @click="Tianjia_zu(shu.$index)"></span>
				</template>
			</el-table-column>
		</el-table>

		<el-table :data="shu" style="margin-top: 20px;" border>
			<el-table-column label="编号" prop="bianhao" width="80"></el-table-column>
			<el-table-column label="组合" prop="ming"></el-table-column>
			<el-table-column label="图片" width="80">
				<template slot-scope="shu">
					<el-avatar shape="square" size="small" :src="shu.row.tu"></el-avatar>
				</template>
			</el-table-column>


			<!-- <el-table-column width="200">
		 <template slot="header" slot-scope="shu" >
		  <span style="padding-right: 5px;">售价</span>
		  <input v-model="jiage"   size="mini" style="width: 50px;height: 24px;border: 1px solid #DCDFE6;border-radius: 4px;" />
		  <i class="el-icon-bottom" @click="Gaijiage(0)" style="padding-left: 8px;"></i>
		 </template>
		 <template slot-scope="shu" >
			 <el-input v-model="shu.row.jiage" @change="Bianhua" />
		 </template>
		</el-table-column>
		
		<el-table-column width="200" >
		 <template slot="header" slot-scope="shu" >
		  <span style="padding-right: 5px;">原价</span>
		  <input v-model="yuanjia"   size="mini" style="width: 50px;height: 24px;border: 1px solid #DCDFE6;border-radius: 4px;" />
		  <i class="el-icon-bottom"  @click="Gaijiage(1)"   style="padding-left: 8px;"></i>
		 </template>
		 <template slot-scope="shu" >
			 <el-input v-model="shu.row.yuanjia" @change="Bianhua" />
		 </template>
		</el-table-column> -->
			<el-table-column width="200">
				<template slot="header" slot-scope="shu">
					<span style="padding-right: 5px;">成本价</span>
					<input v-model="chengben" size="mini"
						style="width: 50px;height: 24px;border: 1px solid #DCDFE6;border-radius: 4px;" />
					<i class="el-icon-bottom" @click="Gaijiage(3)" style="padding-left: 8px;"></i>
				</template>
				<template slot-scope="shu">
					<el-input v-model="shu.row.chengben" @change="Bianhua" />
				</template>
			</el-table-column>
			<el-table-column width="200">
				<template slot="header" slot-scope="shu">
					<span style="padding-right: 5px;">库存</span>
					<input v-model="kucun" size="mini"
						style="width: 50px;height: 24px;border: 1px solid #DCDFE6;border-radius: 4px;" />
					<i class="el-icon-bottom" @click="Gaijiage(2)" style="padding-left: 8px;"></i>
				</template>
				<template slot-scope="shu">
					<el-input v-model="shu.row.kucun" @change="Bianhua" />
				</template>
			</el-table-column>


			<el-table-column width="200">
				<template slot="header" slot-scope="shu">
					<span style="padding-right: 5px;">重量(克)</span>
					<input v-model="zhongliang" size="mini"
						style="width: 50px;height: 24px;border: 1px solid #DCDFE6;border-radius: 4px;" />
					<i class="el-icon-bottom" @click="Gaijiage(4)" style="padding-left: 8px;"></i>
				</template>
				<template slot-scope="shu">
					<el-input v-model="shu.row.zhongliang" @change="Bianhua" />
				</template>
			</el-table-column>







			<!-- 		<el-table-column label="售价" width="200">
				<template slot-scope="shu">
					<el-input v-model="shu.row.jiage" @change="Bianhua" />
				</template>
			</el-table-column>
			
			<el-table-column label="原价" width="200" > 
				<template slot-scope="shu">
					<el-input v-model="shu.row.yuanjia" @change="Bianhua" />
				</template>
			</el-table-column>
			<el-table-column label="库存" width="200">
				<template slot-scope="shu">
					<el-input v-model="shu.row.kucun" @change="Bianhua" />
				</template>
			</el-table-column>
			<el-table-column label="成本价" width="200">
				<template slot-scope="shu">
					<el-input v-model="shu.row.chengben" @change="Bianhua" />
				</template>
			</el-table-column>
			<el-table-column label="重量(克)" width="200">
				<template slot-scope="shu">
					<el-input v-model="shu.row.zhongliang" @change="Bianhua" />
				</template>
			</el-table-column> -->
			</el-table-column>
		</el-table>


		<el-dialog title="规格项" :visible.sync="mianban" width="30%">
			<el-form label-width="80px" :model="mianban_shu">
				<el-form-item label="名称">
					<el-input v-model="mianban_shu.ming"></el-input>
				</el-form-item>
				<el-form-item label="图片" v-if="keyishangtu==0">
					<Shangwenjian v-model="mianban_shu.tu" anniu="上传图片" leixing="tu"></Shangwenjian>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="mianban = false">取 消</el-button>
				<el-button type="primary" @click="Mianban_post">确 定</el-button>
			</span>
		</el-dialog>
	</div>

</template>

<script>
	import Shangwenjian from '../zujian/Shangwenjian.vue'
	export default {
		data() {
			return {
				mianban: false,
				mianban_shu: {},
				keyishangtu: 0,
				lie: [],
				jiage: "",
				yuanjia: "",
				kucun: "",
				chengben: "",
				zhongliang: ''
			}
		},
		props: {
			guigezu: {
				type: Array,
				default () {
					return []
				}
			},
			shu: {
				type: Array,
				default () {
					return []
				}
			}
		},
		created() {
			this.lie = this.shu;
		},
		components: {
			Shangwenjian
		},
		methods: {
			Gaijiage(e) {
				if (e == 0) {
					for (let i in this.shu) {
						this.shu[i].jiage = this.jiage
						this.$set(this.shu, i, this.shu[i])
					}
				} else if (e == 1) {
					for (let i in this.shu) {
						this.shu[i].yuanjia = this.yuanjia
						this.$set(this.shu, i, this.shu[i])
					}
				} else if (e == 2) {
					for (let i in this.shu) {
						this.shu[i].kucun = this.kucun
						this.$set(this.shu, i, this.shu[i])
					}
				} else if (e == 3) {
					for (let i in this.shu) {
						this.shu[i].chengben = this.chengben
						this.$set(this.shu, i, this.shu[i])
					}
				} else if (e == 4) {
					for (let i in this.shu) {
						this.shu[i].zhongliang = this.zhongliang
						this.$set(this.shu, i, this.shu[i])
					}
				}

			},
			//  renderLastHeader(h, { column, $index },index){
			//        return h('span', {}, [
			//         h('span', {}, '原价'),
			// 		h('input', {style:'width:70px;height:20px;margin-left:10px'}),

			// 		h('i', { slot: 'reference', class:'el-icon-bottom',style:'margin-left:10px'},{onClick:this.handleMultipleStop})

			//        ])

			//     },
			// handleMultipleStop(){
			// 	console.log(111111)
			// },
			Tianjia_zu(i) {
				if (i >= 0) {
					this.guigezu.splice(i, 1);
					this.Zuhe();
				} else {
					this.guigezu.push({
						guige: []
					});
				}

			},
			Mianbandakai(e, i) {
				this.mianban = true;
				this.keyishangtu = e.$index;
				if (i >= 0) {
					this._mianban = '';
					this.mianban_shu = e.row.guige[i];
				} else {
					this.mianban_shu = {};
					this._mianban = e.row;
				}
			},
			Mianban_post() {
				if (this.mianban_shu.ming) {
					this.mianban = false;
					if (this._mianban) {
						this._mianban.guige.push(this.mianban_shu);
					}
					this.Zuhe();
				} else {
					this.$xiaoxi('请输入名称');
				}
			},
			Shanchu(a, b) {
				a.splice(b, 1);
				this.Zuhe();
			},
			Zuhe() {
				this.lie = [];
				for (var i = 0; i < this.guigezu.length; i++) {
					this.Shuaxin(this.guigezu[i].guige);
				}
				this.$emit('update:shu', this.lie);
				this.$emit('update:guigezu', this.guigezu);
			},
			Shuaxin(a, b) {
				var z = [];
				var b = 0;
				if (this.lie.length > 0) {
					for (var k = 0; k < this.lie.length; k++) {
						for (var i = 0; i < a.length; i++) {
							z[b++] = {
								ming: this.lie[k].ming + "+" + a[i].ming,
								bianhao: this.lie[k].bianhao + '' + i,
								tu: this.lie[k].tu
							};
						}
					}
					this.lie = z;
				} else {
					for (var i = 0; i < a.length; i++) {
						this.lie.push({
							ming: a[i].ming,
							bianhao: i + "",
							tu: a[i].tu || ""
						});
					}
				}
			},
			Bianhua() {
				this.$emit('update:shu', this.shu);
				this.$emit('update:guigezu', this.guigezu);
			}


		}
	}
</script>

<style>
	.guige .el-icon-circle-plus-outline,
	.guige .el-icon-close {
		font-size: 24px;
		cursor: pointer;
	}

	.guige .el-tag {
		margin-right: 4px;
		display: inline-flex;
		align-items: center;
		cursor: pointer;
	}

	.guige .el-tag img {
		width: 20px;
		height: 20px;
		margin-right: 5px;
	}

	.guige .tianjia_zu {
		margin-left: 10px;
		color: #F56C6C;
	}
</style>